import { ActiveMarketState } from './types';

export const defaultState: ActiveMarketState = {
  all: { bids: [], asks: []},
  error: undefined,
  loading: {
    all: false
  }
};
